import { CountDownTimerWithEvents } from 'services/timer/countdown-timer';
import AsyncBlockService from 'services/loader-handler-services/async-block-service';
import Chaplin from 'chaplin';
import EF from 'ef/ef';

class PageCountDownTimer {
  constructor(settings = {}) {
    this.settings = settings;
    this.modal = this.createModalModel();
    this.pageCountdownTimer = this.createCountdownTimer();
  }

  createModalModel() {
    return new Chaplin.Model({
      type: 'modal',
      id: 'page_inactivity_tracker_modal',
      auto_open: false,
      complete_on_shown: true,
      header: 'pageCountDownTimerModal.header',
      body_class: 'text-center',
      close_caption: 'pageCountDownTimerModal.closeCaption',
      button_class: 'bg-color-interactive-900 font-color-neutral-100',
      blocks: [
        {
          type: 'layout',
          metadata: 'grid/grid-static',
          path: 'grid/grid-static',
          class: 'm-stack-lg',
          regions: [
            {
              columns: 12,
              blocks: [
                {
                  type: 'icon',
                  class: 'm-stack-sm',
                  icon: 'fas fa-clock',
                  classes: 'fa-2x font-color-interactive-900',
                },
                {
                  type: 'header',
                  class: 'h3',
                  h3: ['pageCountDownTimerModal.contentHeader'],
                },
                {
                  type: 'text',
                  class: 'p1',
                  items: [
                    {
                      description: 'pageCountDownTimerModal.contentDescription',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    });
  }

  createCountdownTimer() {
    return new CountDownTimerWithEvents({
      ...this.settings,
      autoplay: false,
      eventPrefix: 'pageCountdownTimer:',
    });
  }

  initialize() {
    try {
      this.pageCountdownTimer.setTickEventPeriod(10);
      this.registerTimerEvents();
      this.loadModalView();
      this.setupEventSubscriptions();
      return this.pageCountdownTimer;
    } catch (err) {
      console.error(`PageCountDownTimer: ${err}`);
      return {};
    }
  }

  resetPageTimer() {
    this.pageCountdownTimer.reset();
    this.pageCountdownTimer.start();
  }

  loadModalView() {
    AsyncBlockService.load(['modal']).then(([ModalView]) => {
      new ModalView({ parent: this, model: this.modal }).load();
    });
  }

  registerTimerEvents() {
    const { eventManager } = this.pageCountdownTimer;

    if (eventManager) {
      this.pageCountdownTimer.on('tick', () => {});
      this.pageCountdownTimer.on('completed', () => {
        if (
          EF.courseTimerService.courseCountdownTimer.state ===
          EF.courseTimerService.courseCountdownTimer.timerStates.completed
        ) {
          // Ignore page timer tracker when seat timer is already completed. We don't want modal to show.
          return;
        }
        console.log('Stopping course level timer', EF.courseTimerService.courseCountdownTimer.timeLeft);
        EF.courseTimerService.courseCountdownTimer.stop();
        Chaplin.mediator.publish('button:clicked:#page_inactivity_tracker_modal');
      });
    }
  }

  setupEventSubscriptions() {
    // Subscribe to the 'page:state:initialized' event to reset the page timer.
    // This ensures the inactivity modal is not triggered while the page is still loading,
    // especially if the user navigates with only 1-2 seconds left before the modal triggers.
    Chaplin.mediator.subscribe('page:state:initialized', this.resetPageTimer.bind(this));

    // Subscribe to the 'dialog:hide' event to handle the hiding of modals.
    // If the 'page_inactivity_tracker_modal' is hidden, resume the countdown timer
    // and reset the page timer to prevent unintended inactivity triggers.
    Chaplin.mediator.subscribe('dialog:hide', ({ id }) => {
      if (id === 'page_inactivity_tracker_modal') {
        EF.courseTimerService.courseCountdownTimer.resume();
        this.resetPageTimer();
      }
    });
  }
}

export default PageCountDownTimer;
